import React from 'react'
import PropTypes from 'prop-types'
import { DialogContent, DialogTitle, IconButton, Dialog as MuiDialog, Typography } from '@mui/material'
import close from 'images/close.svg'
import OrderedList from 'components/OrderedList'
import { useTranslation } from 'react-i18next'

const DisclosureDialog = ({ isDialogOpen = false, closeDialog = () => {}, sortedDiscloures = [] }) => {
    const { t } = useTranslation()

    return (
        <MuiDialog
            fullScreen
            open={isDialogOpen}
            onClose={closeDialog}
            aria-labelledby="disclosures-dialog-title"
            aria-describedby="disclosures-dialog-description"
            data-testid="disclosures-dialog"
            sx={{
                color: 'common.fordBlue.main',
                zIndex: 3000,
                textAlign: 'left',
                '.MuiModal-backdrop': {
                    backgroundColor: 'action.disabledBackground'
                },
                '.MuiDialog-paper': {
                    color: 'common.charcoal.main',
                    backgroundColor: 'background.default',
                    gap: 2,
                    maxHeight: { xs: '100%', sm: '98%' },
                    maxWidth: { xs: 390, md: 570, lg: 871 },
                    borderRadius: { xs: 0, sm: 4 },
                    pt: 3,
                    pb: 8
                },
                '.MuiDialogTitle-root': {
                    fontWeight: 400,
                    p: 0,
                    mx: { xs: 3, md: 3 },
                    ml: { xs: 3, md: 3 },
                    position: 'relative'
                },
                '.MuiDialogContent-root': {
                    p: 0,
                    px: { xs: 3, md: 6 }
                },
                '.MuiDialogActions-root': {
                    p: 0,
                    mx: { xs: 8, md: 10 }
                },
                a: {
                    color: 'primary.main'
                }
            }}
        >
            <DialogTitle>
                <Typography
                    component={'div'}
                    tabIndex={0}
                    variant="regularTitle"
                    sx={{
                        typography: { xs: 'mediumTitle' }
                    }}
                >
                    {t('disclosures')}
                </Typography>
                <IconButton
                    tabIndex={0}
                    aria-label="close"
                    onClick={closeDialog}
                    sx={{
                        color: 'common.fordBlue.main',
                        p: 0,
                        position: 'absolute',
                        right: 0,
                        top: 0
                    }}
                >
                    <img src={close} alt={'close modal'} width={24} height={24} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <OrderedList list={sortedDiscloures}></OrderedList>
            </DialogContent>
        </MuiDialog>
    )
}

DisclosureDialog.propTypes = {
    isDialogOpen: PropTypes.bool,
    closeDialog: PropTypes.func,
    sortedDiscloures: PropTypes.array
}

export default DisclosureDialog
